











































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import AlertArea from "../components/AlertArea.vue";
// @ts-ignore
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 500, interval: 0})
// @ts-ignore
import VueDragResize from "vue-drag-resize";

export class Examinee {
  id: number
  student_no: number
  student_code: string
  student_name: string
  page_count: number
  sheet_activities: SheetActivity[]

  constructor(examinee: any, sheet_activities: any[], base64_images: string[], width: number, height: number, page_count: number){
    this.id = examinee.id;
    this.student_no = examinee.student_no;
    this.student_code = examinee.student_code;
    this.student_name = examinee.student_name;
    this.page_count = page_count;
    this.sheet_activities = sheet_activities.map((x, i) => new SheetActivity(x, base64_images[i], width, height));
  }
}

export class SheetActivity {
  id: number
  page: number
  base64_image: string
  width: number
  height: number
  idx: number

  constructor(sheet_activity: any, base64_image: string, width: number, height: number){
    this.id = sheet_activity.id;
    this.page = sheet_activity.page;
    this.base64_image = base64_image;
    this.width = width;
    this.height = height;
  }
}

export class SheetField {
  id: number
  x: number
  y: number
  width: number
  height: number

  constructor(sheet_field: any){
    this.id = sheet_field.id;
    this.x = sheet_field.rim[0];
    this.y = sheet_field.rim[1];
    this.width = sheet_field.rim[2];
    this.height = sheet_field.rim[3];
  }
}

export class ReviewText {
  id: number
  sheet_activity_id: number
  idx: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
  is_active: boolean = false
}


export interface Data {
  examinee: Examinee,
  examinees: Examinee[]
  examinee_id: number
  pageIdx: number
  inputScale: number
  headerHeight: number
  footerHeight: number
  errors: string[]
  currentReviewText: ReviewText
  isAdjusted: boolean
}

export default defineComponent({
  directives: {
    longclick: longClickInstance
  },
  components: {
    "vue-drag-resize": VueDragResize,
    "alert-area": AlertArea,
  },
  props: {
    sheet_id: {
      type: String as PropType<string>,
      required: true
    },
    examinee_ids: {
      type: Array as PropType<number[]>,
      required: true
    },
    prop_examinee_id: {
      type: Number as PropType<number>,
      required: false
    },
    visible: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    windowHeight: {
      type: Number as PropType<number>,
      required: true
    },
    imageKind: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup (props, context) {

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      examinee: null,
      examinees: [],
      examinee_id: null,
      pageIdx: 0,
      inputScale: 50,
      headerHeight: 45,
      footerHeight: 50,
      errors: [],
      currentReviewText: null,
      isAdjusted: false,
    });

    /************************************************************
     * スライダーの倍率を画像倍率に変換
     ************************************************************/

    const scale = computed(() => {
      return state.inputScale / 100;
    });

    /************************************************************
     * 画像領域の高さ
     ************************************************************/

    const imageAreaHeight = computed((): number => {
      return props.windowHeight - state.headerHeight - state.footerHeight;
    });

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${sheet_activity.value.width * scale.value}px`;
      style["height"] = `${sheet_activity.value.height * scale.value}px`;
      return style;
    });

    /************************************************************
     * 表示対象のsheet_activity
     ************************************************************/

    const sheet_activity = computed((): SheetActivity => {
      return state.examinee.sheet_activities[state.pageIdx];
    });

    /************************************************************
     * サイドバーClose
     ************************************************************/

    const hiddenSidebar = () => {
      context.emit("hidden");
    }

    /************************************************************
     * props.examinee_idの変更監視
     ************************************************************/

    watch(() => props.prop_examinee_id, async (newVal, oldVal) => {
      state.examinee_id = newVal;
    });

    /************************************************************
     * 次の生徒 or 前の生徒ボタン
     ************************************************************/

    const changeExaminee = async (addCount: number) => {
      const newIdx = props.examinee_ids.indexOf(state.examinee.id) + addCount;

      if(newIdx < 0 || newIdx + 1 > props.examinee_ids.length){
        return;
      }

      state.examinee_id = props.examinee_ids[newIdx];
    }

    /************************************************************
     * 表示対象受験者の変更監視
     ************************************************************/

    watch(() => state.examinee_id, async (newVal, oldVal) => {

      if(newVal == null){
        return;
      }
      
      let examinee_cache = state.examinees.filter(x => x.id == newVal);

      // 画像キャッシュなしの場合は画像情報ダウンロード
      if(examinee_cache.length == 0){
        await http.get(`/api/teacher/saiten_list/download_image/${props.sheet_id}/${state.examinee_id}/${props.imageKind}`).then(response => {
          const examinee = new Examinee(response.data.examinee, response.data.sheet_activities, response.data.base64_images, response.data.width, response.data.height, response.data.page_count);
          state.examinees.push(examinee);
          state.examinee = examinee;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }else{
        state.examinee = examinee_cache[0];
      }

      if(state.examinee && state.examinee.page_count < state.pageIdx + 1){
        state.pageIdx = 0;
      }

      if(!state.isAdjusted){
        const imageWrapDiv = document.getElementById(`image-wrap-${props.imageKind}`);
        const width = imageWrapDiv.clientWidth;
        const height = imageWrapDiv.clientHeight;
        const scaleW = width / sheet_activity.value.width;
        const scaleH = height / sheet_activity.value.height;
        state.inputScale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
        state.isAdjusted = true;
      }
    });

    /************************************************************
     * 表示ページ切り替え
     ************************************************************/

    const changePage = (idx: number) => {
      state.pageIdx = idx;
    }
    
    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      
    });

    return {
      ...toRefs(state),
      scale,
      imageAreaHeight,
      imageStyle,
      sheet_activity,
      hiddenSidebar,
      changeExaminee,
      changePage,
    }
  }
});
